const SET_USER_FIELD = 'auth/SET_USER_FIELD'
const SET_USER_FIELDS = 'auth/SET_USER_FIELDS'
const SET_USER_DATA_FIELD = 'auth/SET_USER_DATA_FIELD'
const SET_USER_DATA_FIELDS = 'auth/SET_USER_DATA_FIELDS'
const LOGOUT_USER = 'auth/LOGOUT_USER'

export { SET_USER_FIELD, SET_USER_FIELDS, SET_USER_DATA_FIELD, SET_USER_DATA_FIELDS, LOGOUT_USER }
